/**
 * hd-objtabs.js —— 设计台「对象组」格子（BG / Effects / Size / Shadow / Layers）
 *
 * 2026-09-20 从 sections/design-canvas.liquid 内联段原样外置（10.8 KB）：
 * 该 section 已顶到 Shopify 256KB 上限（余量仅 687 B），外置后余量回到 ~11.5 KB。
 * 行为与内联版完全一致 —— 仅加载时机由「解析期」变为 defer；
 * 本段唯一的监听是 resize（非优先级敏感），初始化走 setTimeout(init,800)，
 * 且全部依赖都在运行时读取 window.__*，故时机变化无影响。
 */
(function(){
  /* 2026-09-20: 过渡期幂等守卫 —— 本文件与内联版（正在下线的那几分钟）可能同时存在，
     若接口已被定义则直接让位，避免新旧两份重复初始化（重复 init / 重复 resize 监听）。 */
  if (typeof window.__pfmObjTab === 'function') return;
  var ICON={fill:'\uD83C\uDFA8',size:'\uD83D\uDCD0',shadow:'\uD83C\uDF17',path:'\u27B0',bg:'\u2702\uFE0F',effects:'\uD83D\uDDBC\uFE0F',copy:'\uD83D\uDD00',bool:'\uD83E\uDDE9',layers:'\uD83D\uDCD1',text:'\uD83D\uDD24'};
  var LABEL={fill:'Fill',size:'Size',shadow:'Shadow',path:'Path',bg:'BG',effects:'Effects',copy:'To face',bool:'Bool',layers:'Layers',text:'Text'};
  /* 6 格固定；后缀 * = 置灰（该对象不适用） */
  var CFG={
    shape:['fill','size','shadow','path','layers'],
    line :['fill*','size','shadow','path','layers'],
    text :['fill','size','shadow*','path*','layers','text'],
    image:['bg','effects','size','shadow','layers'],
    multi:['fill','size','shadow','bool','layers']
  };
  function g(id){return document.getElementById(id);}
  function isMobile(){ try{ return !!(window.__pfmTouchLayout && window.__pfmTouchLayout()); }catch(e){ return false; } }
  function canvas(){ return window.__pfmCanvas || null; }
  function kindOf(o){
    if(!o) return null;
    var t=String(o.type||'');
    if(t==='activeSelection') return 'multi';
    if(t==='image') return 'image';
    if(t==='i-text'||t==='text'||t==='textbox') return 'text';
    if(t==='line') return 'line';
    if(t==='rect'||t==='ellipse'||t==='circle'||t==='triangle'||t==='polygon'||t==='path') return 'shape';
    /* 2026-09-19: 组合（Group）此前落到 null ⇒ 选中组合后对象组整体消失、回落素材模式，
       属性面板失效（图层面板明明有 Group 按钮）。归到 multi 配置：Fill/Size/Shadow/Bool/Layers。 */
    if(t==='group') return 'multi';
    return null;
  }
  function props(){ return g('pfmProps'); }
  /* 2026-09-19: 对象模式下必须隐藏全部素材面板 —— 否则属性区块下面还跟着上传/贴纸区
     （真机截图发现：#pfmPathSection 下面是 "Click or drop image here"）。
     Back 时再恢复上次那个素材面板，避免抽屉空掉。 */
  var _lastTools=null;
  /* 2026-09-19: 上一次同步的对象引用 —— 用来区分「换了对象」与「同一对象的重复同步」。 */
  var _syncObj=null;
  /* 2026-09-19: Back 入口已删 ⇒ 用「是否刚在对象模式里」来判定退回时要恢复素材面板。 */
  var _wasObj=false;
  function hidePanels(){
    var ps=document.querySelectorAll('.pfm-panel');
    for(var pi=0;pi<ps.length;pi++) ps[pi].style.display='none';
  }
  function currentToolsPanel(){
    var list=['upload','text','clipart','layers','shape','pen'];
    for(var ti=0;ti<list.length;ti++){
      var te=g('panel-'+list[ti]); if(te && te.style.display==='block') return list[ti];
    }
    return null;
  }
  function setTab(t){
    var p=props(); if(!p) return;
    if(t) p.setAttribute('data-objtab',t); else p.removeAttribute('data-objtab');
  }
  function setActive(btn){
    document.querySelectorAll('.pfm-stab').forEach(function(b){ b.classList.remove('sel'); });
    if(btn) btn.classList.add('sel');
  }
  /* 按对象类型配置 6 个格子 */
  function paint(kind){
    var cfg=CFG[kind]||null;
    for(var i=0;i<6;i++){
      var btn=g('pfmObjTab'+i); if(!btn) continue;
      var spec=(cfg&&cfg[i])||'';
      btn.style.display='';
      if(!spec){ btn.style.display='none'; continue; }
      var off=spec.slice(-1)==='*';
      var key=off?spec.slice(0,-1):spec;
      btn.setAttribute('data-objtab',key);
      if(off) btn.setAttribute('data-off','1'); else btn.removeAttribute('data-off');
      btn.title=LABEL[key]||key;
      var ic=btn.querySelector('.pfm-stab-ico'), lb=btn.querySelector('.pfm-stab-lbl');
      if(ic) ic.textContent=ICON[key]||'';
      if(lb) lb.textContent=LABEL[key]||key;
    }
  }
  function showGroup(which){
    var tg=g('pfmTabTools'), og=g('pfmTabObj');
    if(tg) tg.style.display = (which==='obj' ? 'none' : '');
    if(og) og.style.display = (which==='obj' ? '' : 'none');
  }
  /* 点对象 tab */
  window.__pfmObjTab=function(btn){
    var t=btn&&btn.getAttribute('data-objtab');
    if(!t || btn.getAttribute('data-off')==='1') return;
    /* 2026-10-13（甲）：Effects / BG ↔ Layers 互斥。对象格这条路的面板显隐由本文件 +
       `__pfmOpenPanel` / `hidePanels()` 决定 ⇒ 必须先清掉 hd-image 侧的两处记忆，否则
       `__hdImage.close()` 会走「收起抽屉」(byCell) 或「0ms 后恢复上一个素材面板」(prevPanel)
       分支 —— 前者把刚打开的 Layers 抽屉收掉，后者把旧面板盖在 Layers 上（两栏同屏）。
       ⚠️ 只清记忆、不删下方对 `__pfmFxByCell=true` 的写入（点 Effects 格仍照常标记）。 */
    window.__pfmFxByCell=false;
    window.__pfmFxPrevPanel=null;
    /* 2026-09-19: 记下「点这一格之前」的高亮格 —— 效果面板从本格收起时要回到它，
       否则一律落回默认格（Size），用户报「我选 effects，关闭后指示器变成 size，这是错的」。 */
    /* 2026-09-19: 「进 Effects 之前那一格」= **上一次被点过的格**（__pfmObjLastKey）——
       效果面板从本格收起时回到它，否则一律落回默认格（Size）。
       ⚠️ 不能用「当前高亮格」判断来源：**Layers 格点完后高亮会被清空**（实测 sel=null），拿不到。
       ⚠️ 只在点 Effects 时记录，且不覆盖已成 effects 的值（第二次点是收起，那时 LastKey 已变）。 */
    var _pv=window.__pfmObjLastKey;
    if(t==='effects' && _pv && _pv!=='effects') window.__pfmObjPrevKey=_pv;
    setActive(btn);
    /* 2026-09-19: 记住「用户最后点的格 + 当时的对象」—— sync() 靠它区分
       「同一对象的重复同步（保持现状）」与「换了对象（重新定位默认格）」。 */
    window.__pfmObjLastKey=t; window.__pfmObjLastObj=canvas()?canvas().getActiveObject():null;
    /* 2026-09-19: 切到别的属性时先关掉「Image effects」面板 —— 它不是 .pfm-section，
       不参与 tab 过滤；不关的话它会挂在 Fill/Size 区块上方，看起来像"上一个属性还在"。 */
    if(t!=='effects'){ try{ if(window.__hdImage&&window.__hdImage.close) window.__hdImage.close(); }catch(e){} }
    if(t==='layers'){ window.__pfmObjAct=null; setTab(null); if(window.__pfmOpenPanel) window.__pfmOpenPanel('layers');
      /* 2026-09-20: __pfmOpenPanel 按 .pfm-stab **全域**清高亮、再加给「素材组」的同名 tab ⇒
         对象组这一格的高亮会被抢走（用户报「点 Layers 高亮跳走 / 跳回 Size」）。这里补一次，
         保证同一时刻只剩本格高亮（素材组该 tab 的 .sel 也一并被 setActive 清掉）。 */
      setActive(btn); }
    else if(t==='bg'){
      hidePanels();
      var bgB=g('pfmImgBtnBg'); if(bgB && !bgB.disabled){ try{ bgB.click(); }catch(e){} }
      /* 2026-09-19: 去底是即时动作、没有对应区块。它引发的**异步**同步会把 objtab 重设回 size
         （抽屉里白跟一段「尺寸」）⇒ 用「动作格」标记让 sync 期间保持清空，直到用户点别的格。 */
      window.__pfmObjAct={btn:btn, obj:(canvas()?canvas().getActiveObject():null)}; setTab(null);
    }
    else if(t==='effects'){
      hidePanels();
      var fx=g('pfmImgBtnFx'); if(fx && !fx.disabled){
        /* 标记「本次点击来自本格」—— 若这一步是收起，hd-image 侧据此回到上一格 */
        window.__pfmFxByCell=true;
        try{ fx.click(); }catch(e){}
      }
      window.__pfmObjAct={btn:btn, obj:(canvas()?canvas().getActiveObject():null)}; setTab(null);   /* 同上：动作格期间 sync 不接管 */
    }
    else if(t==='text'){
      /* 2026-10-14（甲）：文字对象的「内容编辑」格。
         桌面端 #panel-text 常驻，手机端却被 sync() 的 hidePanels() 收走 + 素材组被隐藏 ⇒ 无入口。
         本格放行它：① 先 hidePanels() 关掉一切（含自身），再单独 block ⇒ 同一时刻只有它；
         ② setTab(null) ⇒ 手机块 CSS（.pfm-props:not([data-objtab]) .pfm-section）隐藏全部属性区块；
         ③ #panel-text 是 .pfm-panel 而非 .pfm-section ⇒ 不受该 !important 影响，block 生效。
         抽屉开合仍走末尾统一的 __pfmDrawerOpen()。 */
      window.__pfmObjAct=null; hidePanels(); setTab(null);
      var _pt=g('panel-text'); if(_pt) _pt.style.display='block';
    }
    else{ window.__pfmObjAct=null; hidePanels(); setTab(t); }
    if(window.__pfmDrawerOpen){ try{ window.__pfmDrawerOpen(); }catch(e){} }
  };
  /* 选中/取消 → 切换两组 + 重绘格子 */
  function sync(){
    if(!isMobile()){ setTab(null); showGroup('tools'); return; }
    var c=canvas(); if(!c) return;
    var o=null; try{ o=c.getActiveObject(); }catch(e){}
    var k=kindOf(o);
    if(!k){
      window.__pfmObjAct=null; setTab(null); showGroup('tools');
      /* 2026-09-19: 取消选中 ⇒ 一并清掉「同一对象」记忆。否则重新选中**同一个对象**时，
         sync 开头的「保持现状」会直接 return、跳过 paint/showGroup/setTab ⇒ 属性区块空白
         （压力测试：反复取消/选中同一对象，第 2 次起复现）。 */
      _syncObj=null; window.__pfmObjLastObj=null; window.__pfmObjLastKey=null;
      /* 从对象模式退回：把上次那个素材面板放回来（只改 display，**不主动开抽屉**）——
         否则 hidePanels() 之后抽屉里只剩常驻条，而 Back 已经删了。 */
      if(_wasObj){
        _wasObj=false;
        /* 2026-09-19: 先隐藏其他素材面板 —— 否则会与 __pfmOpenPanel 留下的那个同时显示（审计实测 text+layers 同屏）。 */
        hidePanels();
        var pe2=g('panel-'+(_lastTools||'upload')); if(pe2) pe2.style.display='block';
        /* 2026-09-20: 退回素材模式时把高亮交给当前那个素材 tab —— 否则高亮还留在（已隐藏的）对象格上，
           素材组看起来「没有任何 tab 被选中」。与 setActive 同一套语义（同时刻只有一个高亮）。 */
        var _tb=document.querySelector('.pfm-stab[data-panel="'+(_lastTools||'upload')+'"]');
        document.querySelectorAll('.pfm-stab[data-panel]').forEach(function(b){ b.classList.remove('sel'); });
        if(_tb) _tb.classList.add('sel');
      }
      return;
    }
    /* 2026-09-19: 动作锁只对**同一个对象**有效 —— 换了对象就自动解锁。
       否则点过 BG/Effects 后再切换对象，属性面板会永久空白（压力测试复现）。 */
    if(window.__pfmObjAct && window.__pfmObjAct.obj!==o) window.__pfmObjAct=null;
    paint(k);
    showGroup('obj');
    _lastTools=_lastTools||currentToolsPanel();
    _wasObj=true;
    /* 2026-09-19: **同一对象被再次同步 ⇒ 完全保持现状**（tab / 面板 / 高亮都不动）。
       resize（手机地址栏伸缩、转屏）与 selection:updated（再点一下该对象）都会走到这里；
       原先一律 `hidePanels()+setTab(first=Size)` ⇒ 用户点完 Shadow / To face / Layers
       只要滑动页面就被打回「尺寸」（真机截图 + 脚本双向复现）。
       换了对象才清掉格记忆，回到「自动定位到默认格」的旧行为。 */
    if(_syncObj===o && window.__pfmObjLastObj===o) return;
    /* 2026-09-20（用户方案 B）：**停留在 Layers 时抗换对象** ——
       图层面板是「管理 / 多选」面板：在里面点行换一个对象，不该被踢回默认格（Size）。
       判据 = 最后点的是 Layers 格 **且** Layers 面板确实开着；满足则保持 tab / 面板 / 高亮不动，
       只更新「当前对象」记忆（后续对同一对象的重复同步仍走上面的「保持现状」早退）。 */
    var _lp=g('panel-layers'), _lc=g('pfmObjTab4');
    if(_lc && _lc.classList.contains('sel') && _lp && _lp.style.display==='block'){
      /* 2026-09-20（用户方案 B）：**Layers 面板在显示时就抗换对象**。
         判据刻意**不依赖格记忆**：``__pfmObjLastKey`` 在「取消选中」那一步会被清成 null，
         而那时 Layers 面板通常还留着（`_lastTools==='layers'`）⇒ 用 key 判断会漏掉
         「取消选中 → 再选对象」这条路（实测仍被踢回 Size）。
         为什么「面板在显示」就够：对象模式下**只有点 Layers 格**才会让该面板显示，
         点别的属性格都会 hidePanels() 把它关掉 ⇒ 面板可见 == 用户停在 Layers。
         这里只更新「当前对象」记忆（对同一对象的重复同步仍走上面的「保持现状」早退）。 */
      _syncObj=o; window.__pfmObjLastObj=o;
      return;
    }
    _syncObj=o;
    if(window.__pfmObjLastObj!==o) window.__pfmObjLastKey=null;
    hidePanels();
    setTab(null);
    /* 默认高亮第一个可用格（不自动开抽屉，保持原有交互节奏） */
    var first=null;
    /* 2026-09-19: 选默认格时**跳过不放行属性区块的三格**（不放行 = 由各自面板/即时动作负责）。
       image 的首格就是第一格 ⇒ 原来 first 落到它 ⇒ 走后面的分支清掉属性 ⇒
       CSS 把所有区块过滤掉、素材面板又已被隐藏 ⇒ **抽屉全空白**（用户报「属性抽屉，全部空白」）。
       跳过之后 image 的 first 落到 size ⇒ 抽屉显示「尺寸」区块；那两个格仍可点击开各自面板。 */
    for(var i=0;i<6;i++){
      var btn=g('pfmObjTab'+i);
      if(!btn || btn.style.display==='none' || btn.getAttribute('data-off')==='1') continue;
      var bk=btn.getAttribute('data-objtab');
      if(bk==='bg'||bk==='effects'||bk==='layers'||bk==='text') continue;
      first=btn; break;
    }
    setActive(first);
    var ft=first&&first.getAttribute('data-objtab');
    if(ft==='layers'||ft==='bg'||ft==='effects'){ setTab(null); } else if(ft){ setTab(ft); }
    /* 2026-09-19: 处于「动作格」（BG/Effects）时 sync 一律保持清空 —— 否则异步同步会把
       刚点完 BG 的 objtab 重设回 size（实测抽屉里多出一段「尺寸」）。 */
    if(window.__pfmObjAct){ setTab(null); if(window.__pfmObjAct.btn) setActive(window.__pfmObjAct.btn); }
  }
  function init(){
    var c=canvas();
    if(!c){ setTimeout(init,400); return; }
    try{
      c.on('selection:created',sync);
      c.on('selection:updated',sync);
      c.on('selection:cleared',sync);
    }catch(e){}
    sync();
    window.__pfmObjSync=sync;
  }
  setTimeout(init,800);
  window.addEventListener('resize',function(){ setTimeout(sync,60); });
})();
